import React from 'react';
import { BookingsTableData, BookingTableCellProps } from './helpers';
import cn from 'classnames';
import styles from './BookingsTable.module.css';
import capitalize from 'lodash/capitalize';
import Badge from '../../../ui/Badge/Badge';

const CampaignTypeCell = <T extends BookingsTableData>({ value }: BookingTableCellProps<T>) => (
    <Badge className={cn(styles.badge, styles[value?.toLowerCase()])}>{capitalize(value)}</Badge>
);

export default CampaignTypeCell;
